import { configureStore } from "@reduxjs/toolkit";
import alertMessage from "../slice/alertMessage";

const store = configureStore({
  reducer: {
    alertMessage: alertMessage,
  },
});

export default store;
